/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {RemovalPoint} from '../../../_models/removal-point';

@Component({
  selector: 'app-display-removal-point-details',
  templateUrl: './display-removal-point-details.component.html',
  styleUrls: ['./display-removal-point-details.component.scss']
})
export class DisplayRemovalPointDetailsComponent implements OnInit, OnChanges {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() data: RemovalPoint;
  @Input() fontBold: boolean;
  @Input() oneLine: boolean;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PROPERTIES                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public isOpen = true;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    this.fontBold = false;
    this.oneLine = false;
  }

  ngOnInit() {
    // This is intentional
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  public toggle(): void {
    this.isOpen = !this.isOpen;
  }

}
